var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgImage = function SvgImage(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "data-width-14": 11,
    "data-width-16": 12,
    "data-width-20": 15,
    "data-width-24": 18,
    "data-width-28": 21,
    "data-width-32": 24,
    "data-width-36": 27,
    "data-width-40": 30,
    viewBox: "0 0 11.75 11.7",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10.167 11.667H1.5a1.5 1.5 0 0 1-1.5-1.5V1.5A1.5 1.5 0 0 1 1.5 0h5.78a1.83 1.83 0 0 1 1.333.54l2.547 2.547a1.83 1.83 0 0 1 .54 1.333v5.747a1.5 1.5 0 0 1-1.533 1.5M1.5 1a.507.507 0 0 0-.5.5v8.667a.507.507 0 0 0 .5.5h8.667a.507.507 0 0 0 .5-.5v-5.78a.83.83 0 0 0-.247-.593L7.873 1.247A.84.84 0 0 0 7.28 1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M3.989 3.478a.511.511 0 1 0 0 1.022.511.511 0 0 0 0-1.022M2.5 3.99a1.489 1.489 0 1 1 2.978 0 1.489 1.489 0 0 1-2.978 0M8.056 4.834a.49.49 0 0 1 .573.001l2.763 1.982a.489.489 0 1 1-.575.791L8.34 5.834l-6.824 4.905a.489.489 0 1 1-.571-.794z",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgImage);
export default ForwardRef;